export default __webpack_public_path__ + "static/media/skippedmeal_3.76f30b6c.jpg";